import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

type Percentage = {
	men_exposed: number;
	women_exposed: number;
	other_exposed: number;
};

interface PercentageBarProps {
	menExposed: number;
	womenExposed: number;
	otherExposed: number;
	percentages: Percentage;
}

const defaultPercentage = {
	men_exposed: 0,
	women_exposed: 0,
	other_exposed: 0
};

export function PercentageBar({
	menExposed = 0,
	womenExposed = 0,
	otherExposed = 0,
	percentages = defaultPercentage
}: Readonly<PercentageBarProps>): JSX.Element {
	return (
		<Row>
			<Col span={24}>
				<Row>
					<S.StyledColForPercentage span={4}>
						<Row>
							<S.StyledColForCirlceIcon>
								<span style={{ display: 'flex', marginTop: '0.8rem' }}>
									<S.StatusIncon style={{ backgroundColor: '#2F54EB' }} />
								</span>
							</S.StyledColForCirlceIcon>
							<Col span={20}>
								<S.CustomParagraph>
									{I18n.get('Men')}: <span style={{ color: '#2F54EB' }}>{menExposed}</span>
								</S.CustomParagraph>
							</Col>
						</Row>
					</S.StyledColForPercentage>
					<S.StyledColForPercentage span={4}>
						<Row>
							<S.StyledColForCirlceIcon>
								<span style={{ display: 'flex', marginTop: '0.8rem' }}>
									<S.StatusIncon style={{ backgroundColor: '#EFAC1E' }} />
								</span>
							</S.StyledColForCirlceIcon>
							<Col span={20}>
								<S.CustomParagraph>
									{I18n.get('Women')}: <span style={{ color: '#EFAC1E' }}>{womenExposed}</span>
								</S.CustomParagraph>
							</Col>
						</Row>
					</S.StyledColForPercentage>
					<S.StyledColForPercentage span={4}>
						<Row>
							<S.StyledColForCirlceIcon>
								<span style={{ display: 'flex', marginTop: '0.8rem' }}>
									<S.StatusIncon style={{ backgroundColor: '#17A93B' }} />
								</span>
							</S.StyledColForCirlceIcon>
							<Col span={20}>
								<S.CustomParagraph>
									{I18n.get('Others')}: <span style={{ color: '#17A93B' }}>{otherExposed}</span>
								</S.CustomParagraph>
							</Col>
						</Row>
					</S.StyledColForPercentage>
				</Row>
			</Col>
			<Col span={24}>
				<S.StyledPercentageDiv>
					<S.MenExposed percentage={percentages.men_exposed}>
						{Number(Math.round(percentages.men_exposed)) > 5 && (
							<strong>{Math.round(percentages.men_exposed)}%</strong>
						)}
					</S.MenExposed>
					<S.WomenExposed percentage={percentages.women_exposed}>
						{Number(Math.round(percentages.women_exposed)) > 5 && (
							<strong>{Math.round(percentages.women_exposed)}%</strong>
						)}
					</S.WomenExposed>
					<S.OtherExposed percentage={percentages.other_exposed}>
						{Number(Math.round(percentages.other_exposed)) > 5 && (
							<strong>{Math.round(percentages.other_exposed)}%</strong>
						)}
					</S.OtherExposed>
				</S.StyledPercentageDiv>
			</Col>
		</Row>
	);
}
